import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PAYROLL_ACCOUNTING } from './get-payroll-accounting.hook';

export const UPDATE_DATEV_FILE = gql`
  mutation updateDatevPayrollAccountingFile($payload: UpdatePayrollAccountingInput!) {
    updateDatevPayrollAccountingFile(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateDatevPayrollAccountingFile = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('payrollAccounting');
  const [updateDatevPayrollAccountingFile] = useMutation(UPDATE_DATEV_FILE, {
    onCompleted: data => {
      if (data?.updateDatevPayrollAccountingFile?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('notifications.fileUpdated'),
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAYROLL_ACCOUNTING],
  });
  return updateDatevPayrollAccountingFile;
};
